import React from "react";

/** Filter pill button used on Registrations screen. */
export default function Pill({ label, value, icon: Icon, active, onClick, tint, testId }) {
  const base = "px-3 py-2 border text-xs uppercase tracking-widest flex items-center gap-1 transition-colors";
  const styleActive = "border-red-600 text-white bg-red-600/10";
  const styleTintEmerald = "border-emerald-500/30 text-emerald-400";
  const styleTintAmber = "border-amber-500/30 text-amber-400";
  const styleIdle = "border-white/10 text-zinc-400 hover:border-white/30";
  const cls = [base, active ? styleActive : (tint === "emerald" ? styleTintEmerald : tint === "amber" ? styleTintAmber : styleIdle)].join(" ");
  return (
    <button type="button" onClick={onClick} className={cls} data-testid={testId}>
      {Icon && <Icon size={12}/>}{label}
      <span className="text-[10px] text-zinc-500 ml-1">({value})</span>
    </button>
  );
}
